<template>
	<section class="dp-layout exam-room-layout">
		<!-- 左侧组织架构树 -->
		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<!-- 右侧核心工作区（与人员管理等页面一致的标准 dp-right） -->
		<section class="dp-right">
			<!-- 顶部概览 -->
			<div class="metrics-grid">
				<div class="metric-card card-blue">
					<div class="metric-icon">
						<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none">
							<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
							<polyline points="9 22 9 12 15 12 15 22"></polyline>
						</svg>
					</div>
					<div class="metric-content">
						<div class="metric-value">{{ total || 0 }}</div>
						<div class="metric-label">考场总数</div>
					</div>
				</div>
				<div class="metric-card card-green">
					<div class="metric-icon">
						<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none">
							<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
							<circle cx="9" cy="7" r="4"></circle>
							<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
							<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
						</svg>
					</div>
					<div class="metric-content">
						<div class="metric-value">{{ totalCapacity }}</div>
						<div class="metric-label">总容纳人数</div>
					</div>
				</div>
				<div class="metric-card card-purple">
					<div class="metric-icon">
						<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none">
							<rect x="3" y="3" width="7" height="7"></rect>
							<rect x="14" y="3" width="7" height="7"></rect>
							<rect x="14" y="14" width="7" height="7"></rect>
							<rect x="3" y="14" width="7" height="7"></rect>
						</svg>
					</div>
					<div class="metric-content">
						<div class="metric-value">{{ currentDepartmentName || '全部校区' }}</div>
						<div class="metric-label">当前选定机构</div>
					</div>
				</div>
			</div>

			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

						<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
				@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column type="index" label="序号" width="65" align="center"></el-table-column>
				<el-table-column prop="RoomName" label="考场名称" min-width="120">
					<template slot-scope="scope">
						<span class="room-name-text">{{ scope.row.RoomName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="DepartmentName" label="所属班级" min-width="150" :formatter="formatDepartmentNameCol"></el-table-column>
				<el-table-column label="考场布局" width="130" align="center">
					<template slot-scope="scope">
						<el-tag size="small" type="info">
							{{ scope.row.RowCount }} 行 × {{ scope.row.ColumnCount }} 列
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="Capacity" label="考场容量" width="100" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.Capacity }} 人</span>
					</template>
				</el-table-column>
				<el-table-column prop="Building" label="所属楼宇/区域" min-width="140"></el-table-column>
				<el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="CreateBy" label="创建人" width="120" align="center"></el-table-column>
				<el-table-column prop="CreateTime" label="创建时间" width="160" align="center" :formatter="formatCreateTime"></el-table-column>
			</el-table>

			<el-col :span="24" class="toolbar">
				<el-pagination background layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
					:page-size="PageSize" :total="total" style="float: right"></el-pagination>
			</el-col>

			<!-- 弹窗表单 -->
			<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
				width="560px" @close="handleDialogClose">
				<el-form :model="formData" label-width="110px" :rules="formRules" ref="formRef">
					<el-form-item label="考场名称" prop="RoomName">
						<el-input v-model="formData.RoomName" placeholder="请输入考场名称，例如：物理实验室01" auto-complete="off"></el-input>
					</el-form-item>
					
					<el-form-item label="对应班级" v-if="options && options.length > 0" prop="Dids">
						<el-cascader placeholder="请选择或搜索具体的考场对应班级" style="width: 100%" v-model="formData.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<div class="form-row-grid">
						<el-form-item label="布局行数" prop="RowCount">
							<el-input-number v-model="formData.RowCount" :min="1" :max="30" controls-position="right" style="width: 100%"></el-input-number>
						</el-form-item>
						<el-form-item label="布局列数" prop="ColumnCount">
							<el-input-number v-model="formData.ColumnCount" :min="1" :max="30" controls-position="right" style="width: 100%"></el-input-number>
						</el-form-item>
					</div>

					<el-form-item label="考场容量" prop="Capacity">
						<el-input v-model.number="formData.Capacity" type="number" placeholder="请输入最大考场容纳人数" auto-complete="off">
							<template slot="append">人</template>
						</el-input>
					</el-form-item>

					<el-form-item label="楼宇/区域" prop="Building">
						<el-input v-model="formData.Building" placeholder="请输入所属大楼、楼层..." auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="备注说明" prop="Remark">
						<el-input type="textarea" :rows="3" placeholder="请输入关于该考场的额外说明..." v-model="formData.Remark"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="dialogVisible = false" size="small">取消</el-button>
					<el-button type="primary" @click.native="submitForm" :loading="submitLoading" size="small">确认提交</el-button>
				</div>
			</el-dialog>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getExamRoomListPage, editExamRoom, addExamRoom, deleteExamRoom } from '../../api/modules/exam';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { prepareDeptCascaderTree, normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps'
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'

export default {
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			SchoolId: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, // 接口API基地址
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			dialogVisible: false, // 对话框可见状态
			isEditMode: false, // 是否是编辑模式
			dialogTitle: '', // 对话框标题
			submitLoading: false, // 提交中状态
			formData: {
				Id: 0,
				RoomName: '',
				Dids: [],
				RowCount: 1,
				ColumnCount: 1,
				Capacity: 0,
				Building: '',
				Remark: '',
				DepartmentId: 0
			},
			formRules: {
				RoomName: [{ required: true, message: '请输入考场名称', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择考场对应班级', trigger: 'change' },
				],
				RowCount: [
					{ required: true, message: '请输入行数', trigger: 'blur' }
				],
				ColumnCount: [
					{ required: true, message: '请输入列数', trigger: 'blur' }
				],
				Capacity: [
					{ required: true, message: '请输入考场容量', trigger: 'blur' }
				]
			},
			DepartmentId: 0,
			multipleSelection: [],
			currentDepartmentName: '',
		}
	},
	computed: {
		// 动态统计当前列表里的考场总容纳量
		totalCapacity() {
			if (!this.users || this.users.length === 0) return 0;
			return this.users.reduce((sum, current) => sum + (Number(current.Capacity) || 0), 0);
		}
	},
	methods: {
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		// 获取考场列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true
			getExamRoomListPage(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
			}).catch(() => {
				this.listLoading = false
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		// 统一打开新增或修改 Dialog
		showDialog(isEdit = false) {
			var row = this.multipleSelection
			if (isEdit) {
				if (row.length == 0 || row.length > 1) {
					this.$message({
						message: '请选择一行数据进行编辑！',
						type: 'error',
					})
					return
				}
				this.formData = Object.assign({}, row[0])
				this.dialogTitle = '编辑考场'
				this.isEditMode = true
			} else {
				if (!this.DepartmentId || this.DepartmentId === 0) {
					this.$message.warning("请先在左侧选择具体的学校机构！");
					return;
				}
				this.formData = {
					Id: 0,
					RoomName: '',
					Dids: [],
					RowCount: 6,
					ColumnCount: 6,
					Capacity: 36,
					Building: '',
					Remark: '',
					DepartmentId: 0
				}
				this.dialogTitle = '新增考场'
				this.isEditMode = false
			}
			this.dialogVisible = true

			let schoolId = this.SchoolId
				|| this.$store.state.activeSchoolId
				|| window.localStorage.getItem('activeSchoolId');
			if (!schoolId && isEdit && row[0].Dids && row[0].Dids.length > 0) {
				schoolId = row[0].Dids.find(id => normalizeDeptId(id)) || '';
			}
			if (!schoolId) {
				schoolId = this.DepartmentId || (isEdit ? row[0].DepartmentId : 0) || 0;
			}
			if (!normalizeDeptId(schoolId)) {
				this.$message.warning("请先选择学校");
				return;
			}

			let para = { pid: 0, scopeDepartmentId: schoolId }
			getTeachingDepartmentTree(para).then((res) => {
				const root = res.data.response;
				const targetNode = this.findSchoolNode(root, schoolId);
				if (targetNode) {
					this.options = prepareDeptCascaderTree([targetNode]);
					if (isEdit) {
						const deptId = row[0].DepartmentId;
						const path = this.findPathByDeptId(targetNode, deptId, []);
						if (path && path.length > 0) {
							this.$set(this.formData, 'Dids', path);
						} else {
							this.$set(this.formData, 'Dids', [targetNode.value]);
						}
					}
				} else {
					this.options = prepareDeptCascaderTree(root ? [root] : []);
					if (isEdit) {
						const deptId = row[0].DepartmentId;
						const path = this.findPathByDeptId(root, deptId, []);
						if (path && path.length > 0) {
							this.$set(this.formData, 'Dids', path);
						}
					}
				}
				this.cascaderKey++; // 触发强制重绘，保证级联选择组件在回显和重绘时显示正常
			})
		},
		handleEdit() {
			this.showDialog(true)
		},
		handleAdd() {
			this.showDialog(false)
		},
		handleDialogClose() {
			this.dialogVisible = false
			if (this.$refs['formRef']) {
				this.$refs['formRef'].resetFields()
			}
		},
		// 提交表单
		submitForm() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交数据吗？', '提示', { type: 'info' }).then(() => {
						this.submitLoading = true
						let para = Object.assign({}, this.formData)
						para.DepartmentId = para.Dids.pop()

						var user = JSON.parse(window.localStorage.user)
						if (!(user && user.uID > 0)) {
							this.$message({
								message: '用户信息为空，请先重新登录',
								type: 'error',
							})
							this.$router.replace(
								this.$route.query.redirect ? this.$route.query.redirect : '/'
							)
							this.submitLoading = false
							return
						}

						if (this.isEditMode) {
							para.ModifyBy = user.uRealName
						} else {
							para.CreateBy = user.uRealName
						}

						const apiCall = this.isEditMode ? editExamRoom : addExamRoom

						apiCall(para).then((res) => {
							this.submitLoading = false
							if (util.isEmt.format(res)) return;

							if (res.data.success) {
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.dialogVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						}).catch(() => {
							this.submitLoading = false
						})
					})
				}
			})
		},
		// 批量或单选删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请至少选择一行数据进行删除！',
					type: 'error',
				})
				return
			}
			this.$confirm('确认删除选中的考场记录吗? 该操作不可撤销。', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteExamRoom(para).then((res) => {
						this.listLoading = false
						if (util.isEmt.format(res)) return;
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}
						this.handleQuery()
					}).catch(() => {
						this.listLoading = false
					})
				})
				.catch(() => { })
		},
		findSchoolNode(node, schoolId) {
			if (!node) return null;
			if (deptIdsEqual(node.value, schoolId)) {
				return node;
			}
			if (node.children && node.children.length) {
				for (let i = 0; i < node.children.length; i++) {
					const found = this.findSchoolNode(node.children[i], schoolId);
					if (found) return found;
				}
			}
			return null;
		},
		findPathByDeptId(node, deptId, path) {
			const currentPath = [...path, node.value];
			if (String(node.value) === String(deptId)) {
				return currentPath;
			}
			if (node.children && node.children.length) {
				for (let i = 0; i < node.children.length; i++) {
					const found = this.findPathByDeptId(node.children[i], deptId, currentPath);
					if (found) return found;
				}
			}
			return null;
		},
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped>
/* 业务布局；滚动由全局 dp-layout/dp-right 统一处理 */
.exam-room-layout .dp-right {
	min-width: 0;
}

/* 顶部概览指标（轻量，不额外套卡片容器） */
.metrics-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	margin-bottom: 16px;
}

.metric-card {
	background: #f8fafc;
	border-radius: 8px;
	padding: 12px 16px;
	display: flex;
	align-items: center;
	gap: 12px;
	border: 1px solid #ebeef5;
}

.metric-icon {
	width: 40px;
	height: 40px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.card-blue .metric-icon {
	background: rgba(64, 158, 255, 0.1);
	color: var(--btn-primary, #2563eb);
}

.card-green .metric-icon {
	background: rgba(103, 194, 58, 0.1);
	color: #67c23a;
}

.card-purple .metric-icon {
	background: rgba(115, 103, 240, 0.1);
	color: #7367f0;
}

.metric-value {
	font-size: 18px;
	font-weight: 700;
	color: #303133;
	line-height: 1.2;
}

.metric-label {
	font-size: 12px;
	color: #909399;
	margin-top: 2px;
}

.room-name-text {
	font-weight: 600;
}

.form-row-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
}
</style>
